export function extensionFromName(name?: string | null): string | undefined {
  if (!name) return undefined;
  return name.split(".").pop()?.toLowerCase() || undefined;
}
